<template lang="pug">
	.chart-container
		.scroll-right(@click="scrollRight" :class="{inactive: scrollRightInActive}" v-if="scrollAvailable") >
		.scroll-left(@click="scrollLeft" :class="{inactive: scrollLeftInActive}" v-if="scrollAvailable") <
		.chart-header(v-if="header>0" :style="{ height: header+'%'}")
			.chart-label {{ headLabel }}
			.chart-description {{ headDescription }}
		chartScale(:height="(100 - footer - header)" :maxScale="maxScale" :range="getRange" :leftLabel="leftLabel" v-if="!showSelect")
		.chart-legend-topLeft(v-if="legendType == 'topLeft' && legendData.length>0")
			.legend-item(v-for="(cld, cli) in legendData" :key="cli") 
				.legend-item-color( :style = "{backgroundColor: cld.color}")
				.legend-item-name( :style = "{color: cld.color}" ) {{ cld.name  }}
		.chart-left-legend(v-if="left>0 && !showSelect" :style="{ height: (100 - footer - header) + '%', width: left + '%' }" :label="legendLabel")
		.chart-body(ref="chartBody" v-if="!showSelect" :style="{ height: (100 - footer - header) + '%', width: (100 - left - right) + '%' }" v-on:scroll.passive="doScroll()")
			chartBody.chart-grower(:tickScale='getTickScale' :barScale='getBarScale' :chartBars='chartSelects.chartItems[selectedItem]' :barDims='barDims' :maxScale='maxScale' :barType="barType" :key='selectedItem' :id='getID'  @loaded="checkIfChartHasScroll")
		.select(v-else :style="{ height: (100 - footer - header) + '%'}")
			.selectCard(flush :style='determinColor')
				.selectGroup(
					v-for="(selection, select_i) in selections"
					:key="selection"
					:style="{color: determinColor}"
				)
					.selectGroupItem(@click="setSelection(select_i)" :style="determinColor") {{ selection  }}
		.chart-right-legend(v-if="right>0 && !showSelect" :style="{ height: (100 - footer - header) + '%', width: right + '%', top: header + '%' }")
		.chart-footer(v-if="footer > 0" :style="{ height: footer+'%' }")
			chartFooterSelect.footer-select(v-if="chartSelects.selectLabel" :id='id' :chartData='chartSelects' :selectedItem='selectedItem' @selectChart='selectChart')
</template>
<style lang="scss" scoped>
 .inactive {
	 color: #555;
	 opacity: 40%;
 }
 .chart-container {
	 width: 100%;
	 height: 100%;
	 margin: 0;
	 padding: 0;
	 position: relative; //positioning absolute element chart-scale
	 .chart-legend-topLeft {
		 position: absolute;
		 margin-left: 6vmin;
		 /* border: .2vmin solid #5a726a; */
		 border-radius: 4vmin;
		 padding: 2vmin;
		 top:-6.5%;
		 .legend-item {
			 .legend-item-name {
				 float:left;
				 font-size: 3vmin;
				 margin-top: .4vmin;
				 text-shadow: .1vmin .1vmin #026A44;
			 }
			 .legend-item-color {
				 float:left;
				 width: 2.5vmin;
				 height: 2.5vmin;
				 margin:1.4vmin;
				 border-radius: .3vmin;
				 clear:both;
			 }
		 }
		 
	 }
	 .scroll-right {
		 position:absolute;
		 right:0;

		 width:8vmin;
		 height:8vmin;
		 font-size:5vmin;
		 cursor:pointer;
		 user-select: none;
		 border-radius: 5vmin;
		 border: .3vmin solid #5a726a;
		 background: white;
		 margin-top: 1.2vh;
		 z-index:1000;
		 
	 }
	 .scroll-left {
		 position:absolute;
		 width:8vmin;
		 height:8vmin;
		 font-size:5vmin;
		 cursor:pointer;
		 user-select: none;
		 border-radius: 5vmin;
		 border: .3vmin solid #5a726a;
		 background: white;
		 margin-top: 1.2vh;
		 z-index:1000;
	 }
	 .chart-header {
		 font-family: $font-serif;
		 font-weight: 700;
		 text-align: right;
		 padding-right: 6%;
		 font-size: 5vmin;
		 background:transparent;
		 height: 25%;
		 width: 100%;
		 .chart-label {
			 margin: 0 2vmin 0 0;
		 }
		 .chart-description {
			 font-size: 2vmin;
		 }
	 }
	 .select {
		 border:1px solid green;
		 height:100%;
		 .selectGroup {
			 float:left;
			 width: 30%;
			 height: 30%;
			 margin: 1%;
			 .selectGroupItem {
				 font-size: 8vmin;
				 cursor:pointer;
				 height: 100%;
				 width: 100%;
				 margin:1%;
				 border-radius: 1vmin;
			 }
		 }
	 }
	 .chart-left-legend {
		 height: 57%;
		 width: 20%;
		 float: left;
	 }
	 .chart-body {
		 float: left;
		 overflow-y: auto;
		 scrollbar-width: none;
		 background:transparent;
		 &::-webkit-scrollbar {
			 display: none;
		 }
	 }
	 .chart-grower {
		 height:100%;
		 overflow-x: hidden;
		 overflow-y: hidden;
		 padding: 0;
		 margin: 0;
		 scrollbar-width: none;
		 &::-webkit-scrollbar {
			 display: none;
		 }

	 }
	 .chart-right-legend {
		 font-family: $font-sans-serif;
		 font-weight: 700;
		 color: #5a726a;
		 height: 57%;
		 width: 20%;
		 float: right;
	 }
	 .chart-footer {
		 height: 10%;
		 width: 100%;
		 background:tranparent;
		 clear: both;
	 }
 }
 @media(max-width: 768px) {
	 .chart-container {
		 .chart-legend-topLeft {
			 margin-left: 6vmin;
			 padding: 4vmin;
			 .legend-item {
				 .legend-item-name {
					 margin-top: .4vmin;
				 }
				 .legend-item-color {
					 width: 2.5vmin;
					 height: 2.5vmin;
					 margin:1.4vmin;
				 }
			 }
			 
		 }
	 }
 }
 @media(max-width: 400px) {
	 .chart-container {
		 .chart-legend-topLeft {
			 margin-left: 6vmin;
			 padding: 5vmin;
			 .legend-item {
				 .legend-item-name {
					 margin-top: .4vmin;
				 }
				 .legend-item-color {
					 width: 2.5vmin;
					 height: 2.5vmin;
					 margin:1.4vmin;
				 }
			 }
			 
		 }
	 }
 }

</style>

<script>
import  { uuid }  from "vue-uuid";
import chartScale from '@/components/charts/chartScale';
import chartBody from '@/components/charts/chartBody';
import chartFooterSelect from '@/components/charts/chartFooterSelect';
import formatNumberReal from '@/lib/utils/formatNumberReal';

export default {
	name       : 'chart-container',
	components : { chartScale, chartBody, chartFooterSelect },
	props : {
		id: {
			type: String,
		},
		leftLabel: {
			type: String
		},
		headLabel: {
			type: String
		},
		headDescription: {
			type: String
		},
		header: {
			type: Number,
			default: 33,
		},
		footer: {
			type: Number,
			default: 10,
		},
		left: {
			type: Number,
			default: 20,
		},
		right: {
			type: Number,
			default: 10,
		},
		legendLabel: {
			type: String,
		},
		chartSelects: {
			type: Object,
		},
		barDims: {
			type: Object
		},
		barType: {
			type: String,
			default: 'normal',
		},
		legendData: {
			type: Array,
		},
		legendType: {
			type: String,
			default: "topLeft",
		}
	},
	data : () => ( {
		numScales: 5,
		selectedItem: 0,
		showSelect: false,
		scrollRightInActive: false,
		scrollLeftInActive: true,
		scrollAvailable: false,
		scrollValue: 0,
		chartCheck:null,
	} ),
	computed : {
		getID() {
			return uuid.v1();
		},
		selections() {
			// (this.chartSelects);
			return this.chartSelects.chartItems.map( obj => obj.selectValue);
		},
		determinColor() {
			const style = { 
				borderRadius: '5vmin',
				background: '#89B831',
				color: 'white',
				marginTop: '1vh'
			};
			console.log(style);
			return style;
		},
		maxScale() {
			console.log('maxScale');
			let values = [];
			for (let li in this.chartSelects.chartItems[this.selectedItem].barGroups) { //eslint-disable-line
				if (this.barType === 'stacked') {
					values.push(this.chartSelects.chartItems[this.selectedItem].barGroups[li].barValues.reduce((a, b) => a + b, 0));
				} else {
					for(var lj in this.chartSelects.chartItems[this.selectedItem].barGroups[li].barValues) { //eslint-disable-line
						values.push(this.chartSelects.chartItems[this.selectedItem].barGroups[li].barValues[lj]);
					}
				}
			}
			if(values.length) {
				values = values.sort((a, b) => a - b);
				const lValue = values.pop();
				const fValue = formatNumberReal(lValue);
				const gValue = fValue[fValue.length -1];
				const hValue = parseFloat(fValue, 10);
				let jValue = hValue;
				
				if(jValue < 1) {
					jValue *= 1.16;
					jValue = Math.ceil(jValue * 10) / 10;
				} else if(jValue < 10) {
					jValue *= 1.16;
					jValue = Math.ceil(jValue*10)/10;
				} else if(jValue < 100) {
					jValue *= 1.16;
					jValue = Math.ceil(jValue);
				} else if(jValue < 1000) {
					jValue = Math.ceil(jValue/100)*100;
				}
				
				switch(gValue) {
				case 'K':
					jValue *= 1000;
					break;
				case 'M':
					jValue *= 1000000;
					break;
				case 'B':
					jValue *= 10000000;
					break;
				default: 
					
					
					break;
				}
				console.log(`lValue ${lValue} fValue: ${fValue} gValue: ${gValue} hValue: ${hValue} jValue: ${jValue}`);
				return jValue;
			}
			return 0;
		},
		getRange() {
			 console.log('vvvvvvvvvvvvvvvvvvvv calcRange vvvvvvvvvvvvvvvvvvvvvvvvvvvv');
			// console.log('calcRange');
			const numScales = this.numScales;
			const inc = this.maxScale/numScales;
			// console.log('maxScale: '+this.maxScale);//eslint-disable-line
			const range = [0];
			for ( let li = 1; li <= numScales; li++ ) {
				// console.log(inc);
				range.push(inc * li);
			}

			const height = 100 - this.footer - this.header;
			// console.log(`Scale: ${height} / ${range.length} = ${height / range.length}`);
			 console.log('^^^^^^^^^^^^^^^^^^^^ calcRange ^^^^^^^^^^^^^^^^^^^^^^^^^^^^');
			return range.reverse();
		},
		getTickScale() {
			const numScales = this.numScales + 2; //plus 2 adds Zero and bottom of div
			const scale = 100 / numScales;
			return scale;
		},
		getBarScale() {
			const numScales = this.numScales + 1; //plus 1 adds Zero and bottom of div
			const scale = 100 / numScales;
			return scale;
		}
	},

	methods : {
		scrollLeft() {
			// console.log(`left:`);
			const content = document.getElementById(this.getID);
			content.parentNode.scrollTo({
				left: content.parentNode.scrollLeft - 500,
				behavior: 'smooth'
			});
			// console.log((content.parentNode.scrollLeft - 500));
			this.scrollValue=content.parentNode.scrollLeft - 500;
			//this.checkScroll();

		},
		scrollRight() {
			// console.log('right');
			const content = document.getElementById(this.getID);
			content.parentNode.scrollTo({
				left: content.parentNode.scrollLeft + 500,
				behavior: 'smooth'
			});
			this.scrollValue=content.parentNode.scrollLeft + 500;
			//this.checkScroll();
		},
		checkScroll() {
			if(this.scrollValue > 0) {
				this.scrollLeftInActive = false;
			} else {
				this.scrollLeftInActive = true;
			}
			// console.log(`scrolltest: ${this.scrollValue} < ${this.scrollMax()}`);
			if(Math.round(this.scrollValue) < this.scrollMax()) {
				this.scrollRightInActive = false;
			} else {

				this.scrollRightInActive = true;
			}
		},
		scrollMax() {
			const content = document.getElementById(this.getID);
			return  content.parentNode.scrollWidth-content.parentNode.offsetWidth;
		},
		getDataRange( yValues, scaled ) {
			console.log(yValues);
			const biggest    = Math.max( ...yValues );
			const start = 0;
			const end   = biggest;
			console.log(end);
			return {
				start,
				end,
			};
		},
		selectChart() {
			// console.log('selectChart');
			this.showSelect = true;
			this.scrollAvailable = false;
		},
		setSelection(selection) {
			// console.log(`setSelection: ${selection}`);
			this.selectedItem=selection;
			this.showSelect = false;
			// console.log(this.chartSelects.chartItems[selection]);
			// console.log('end selection');
		},
		checkIfChartHasScroll(id) {
			console.log(`Check if has scroll: ${id}`);
			
			this.chartCheck = id;
			const v = this;
			this.$nextTick(() => {
				console.log(`ScrollCHeck Values: ${v.$refs.chartBody.scrollWidth} > ${v.$refs.chartBody.clientWidth}`);
				if(v.$refs.chartBody.scrollWidth > v.$refs.chartBody.clientWidth) {
					v.scrollAvailable=true;
				} else {
					v.scrollAvailable=false;
				}
			});
		},
		doScroll() {
			const v = this;
			setTimeout(function () { //eslint-disable-line
				v.scrollValue=v.$refs.chartBody.scrollLeft;
				v.checkScroll();
			}, 100);
			
		},
	},
	created() {
		// console.log('created chart-container');
		// console.log(this.chartSelects);
		// console.log('RANGE');
		// console.log(this.getRange);
		// console.log(this.getTickScale);
		// // // // // // // // // // // // console.log(`scaleHeight: ${100 - this.footer - this.header} footer: ${this.footer}, header: ${this.header}`);
		// console.log('send to chart');
		// console.log(`selectedItem: ${this.selectedItem}`);
		// console.log(this.chartSelects.chartItems[this.selectedItem]);
		this.selectedItem=this.chartSelects.chartItems.length-1;
		// console.log(`SET SELECTED ITEM: ${this.selectedItem}`);

	},

	mounted() {
	},

	watch : {
	},

};
</script>
